import Client from '../HttpClient';

const baseUrl = '/admin/api/menu-category';

const list = () => {
	return Client.get(baseUrl);
};

const find = (code) => {
	return Client.get(`${baseUrl}/${code}`);
};

const create = (payload) => {
	return Client.post(baseUrl, payload);
};

const update = (code, payload) => {
	return Client.put(`${baseUrl}/${code}`, payload);
};

const remove = (code) => {
	return Client.del(`${baseUrl}/${code}`);
};

const sort = (payload) => {
	return Client.put(`${baseUrl}/arrange`, payload);
};

const options = () => {
	return Client.get(`${baseUrl}/refer`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sort,
	options,
};
